module.exports = __webpack_public_path__ + "img/Instagram.8f53cc8c.svg";